import { createI18n } from "vue-i18n";

const messages = {
  en: {
    navbarHome: "/home",
    navbarAbout: "/whoami",
    navbarAboutMobile: "/whoami",
    navbarSkills: "/skills",
    navbarProjects: "/projects",
    navbarContact: "/contact",
    navbarContactMobile: "/contact",
    footer: `© ${new Date().getFullYear()} ANDRIKO Olivier. All rights reserved.`,
    netlify: "Hosted on ",
    welcomeMessage: "Welcome to my portfolio!",
    getStarted: "Let’s get started !",
    aboutFirstParagraph:
      "My name is <strong>Olivier ANDRIKO</strong>, welcome to my portfolio.👋",
    aboutSecondParagraph:
      "Currently completing a Master's degree in cybersecurity, I specialize in pentesting and technical auditing. My strong background in full-stack development is my greatest asset: understanding code architecture allows me to better identify vulnerabilities.",
    aboutThirdParagraph:
      "My passion for offensive security goes beyond academics. I dedicate my free time to practicing on CTFs, analyzing CVEs, and actively monitoring technology to stay ahead of emerging threats.",
    aboutFourthParagraph:
      "Committed to knowledge sharing, I run a {0} where I regularly publish technical analyses, in-depth cybersecurity articles, and detailed writeups of my solutions to various challenges.",
    aboutFifthParagraph:
      "Feel free to contact me if my profile interests you or if you have a project idea !",
    aboutQuickTip:
      "Quick tip : you can navigate through the website using the left and right arrows on your keyboard !",
    aboutQuickTipMobile:
      "Quick tip : you can navigate through the website using the swipe gestures on your phone !",
    firstFolder: "general purpose languages",
    secondFolder: "web & frameworks",
    thirdFolder: "database",
    fourthFolder: "mobile development",
    fifthFolder: "pentesting",
    sixthFolder: "others",
    picpalsDescription:
      "PicPals is a social media platform that allows users to share drawings and connect with friends.",
    vaultyDescription:
      "Encrypted desktop password manager featuring a companion browser extension for seamless credential autofill.",
    portfolioDescription:
      "This website is my portfolio. It was made to improve my skills in front-end development.",
    fileBucketDescription:
      "FileBucket is a simple file server web app that you can deploy locally on your computer.",
    projectsTeaser: "And many more on my ",
    contactTitle: "You've reached the end !",
    contactLinksText:
      "If you appreciate my work or wish to contact me, feel free to check out the following links :",
    blogDescription: "My music/dev blog",
  },
  fr: {
    navbarHome: "/accueil",
    navbarAbout: "/whoami",
    navbarAboutMobile: "/whoami",
    navbarSkills: "/compétences",
    navbarProjects: "/projets",
    navbarContact: "/me contacter",
    navbarContactMobile: "/contact",
    footer: `© ${new Date().getFullYear()} ANDRIKO Olivier. Tous droits réservés.`,
    netlify: "Hébergé sur ",
    welcomeMessage: "Bienvenue sur mon portfolio !",
    getStarted: "C'est parti !",
    aboutFirstParagraph:
      "Je m'appelle <strong>Olivier ANDRIKO</strong>, bienvenue sur mon portfolio.👋",
    aboutSecondParagraph:
      "Actuellement en Master 2 Cybersécurité, je me spécialise dans le pentesting et l'audit technique. Mon solide bagage en développement full-stack constitue aujourd'hui mon atout majeur : comprendre l'architecture du code pour mieux en identifier les vulnérabilités.",
    aboutThirdParagraph:
      "Ma passion pour la sécurité offensive dépasse le cadre académique. Je consacre mon temps libre à la pratique sur des CTF, à l'analyse de CVEs et à la veille technologique active pour rester à jour face aux nouvelles menaces.",
    aboutFourthParagraph:
      "Dans une démarche de partage de connaissances, je tiens un {0} où je publie régulièrement des analyses techniques, des articles de fond sur la cybersécurité ainsi que des writeups détaillés de mes solutions aux challenges rencontrés.",
    aboutFifthParagraph:
      "N'hésitez pas à me contacter si mon profil vous intéresse ou si vous avez une idée de projet !",
    aboutQuickTip:
      "Petit conseil : tu peux naviguer sur le site en utilisant les flèches directionnelles de ton clavier !",
    aboutQuickTipMobile:
      "Petit conseil : tu peux naviguer sur le site en swipant vers la gauche ou la droite !",
    firstFolder: "langages polyvalents",
    secondFolder: "développement web",
    thirdFolder: "bases de données",
    fourthFolder: "développement mobile",
    fifthFolder: "pentesting",
    sixthFolder: "divers",
    picpalsDescription:
      "PicPals est un prototype de réseau social qui permet aux utilisateurs de partager quotidiennement des dessins.",
    vaultyDescription:
      "Un gestionnaire de mots de passe de bureau chiffré avec une extension de navigateur pour un remplissage automatique des identifiants.",
    portfolioDescription:
      "Ce site est mon portfolio. Il m'a permis d'améliorer mes compétences en développement front-end.",
    fileBucketDescription:
      "FileBucket est une application web qui fait office de serveur de fichiers, facilement déployable localement sur votre ordinateur.",
    projectsTeaser: "Et bien d'autres sur mon ",
    contactTitle: "Vous voilà arrivé au bout !",
    contactLinksText:
      "Si vous appréciez mon travail ou que vous voulez me contacter, n'hésitez pas à consulter les liens suivants :",
    blogDescription: "Mon blog de musique/dev",
  },
};

const i18n = createI18n({
  legacy: false,
  locale: "en",
  messages,
});

export default i18n;